import React from 'react';
import PropTypes from 'prop-types';

import CardDeck from '../cardDeck/CardDeck';

import ProductsListItem from './productsListItem/ProductsListItem';
import './ProductsList.css';

/**
 * Products card deck component.
 */
export default function ProductsList({
    itemsProperty,
    query,
    variables,
    limit,
    isEmptyMsg = true,
    renderProduct,
    schemaOrgPreview,
    keyword,
    eagerImageCount = 0,
    prioritizeFirstImage = false,
}) {
    return (
        <div className="ProductsList">
            <CardDeck itemsProperty={itemsProperty} query={query} rowClassName="row-cols-2 row-cols-md-3 row-cols-xl-4"
                      variables={variables} limit={limit} isEmptyMsg={isEmptyMsg}
                      schemaOrgPreview={schemaOrgPreview}
                      keyword={keyword}
            >
            {(product, index) => renderProduct ? renderProduct(product, index) : (
                <div className="ProductsList-item">
                        <ProductsListItem
                            product={product}
                            imageLoading={index < eagerImageCount ? 'eager' : 'lazy'}
                            imageFetchPriority={prioritizeFirstImage && index === 0 ? 'high' : undefined}
                        />
                    </div>
                )}
            </CardDeck>
        </div>
    );
}
ProductsList.propTypes = {
    itemsProperty: PropTypes.string.isRequired,
    query: PropTypes.object.isRequired,
    variables: PropTypes.object,
    limit: PropTypes.number,
    isEmptyMsg: PropTypes.bool,
    renderProduct: PropTypes.func,
    schemaOrgPreview: PropTypes.object,
    keyword: PropTypes.string,
    eagerImageCount: PropTypes.number,
    prioritizeFirstImage: PropTypes.bool,
};
